import Vue from 'vue'
import VueRouter from 'vue-router'
import tagAchives from '../pages/tagArchives.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/tag/:name', component: tagAchives },
  { path: '/tag/:name/:year/:month', component: tagAchives },
  { path: '/:channel/tag/:name', component: tagAchives },
  { path: '/:channel/tag/:name/:year/:month', component: tagAchives }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})
router.afterEach((to, from) => {
  ga('send', 'pageview', to)
})
export default router
